$(document).ready(function() {
  $('.product-images-alternate-slider.slider-nav').slick({
    centerMode: true,
    centerPadding: '12%',
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.product-images-alternate-slider.slider-for',
    focusOnSelect: true
  });
   $('.product-images-alternate-slider.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.product-images-alternate-slider.slider-nav'
  });

  // Get the modal element
  var modalEl = $('.alternate-slider-modal');
  // Get all '.product-image-alternate-slide' elements
  var slideElements = $('.product-image-alternate-slide');
  // Get the close element
  const closeBtn = $('.close-alternate-slider-modal');

  // Attach a click event listener to each slide element
  slideElements.on('click', function() {
    // Change the display property of '.product-images-alternate-slider.slider-for'
    modalEl.css('visibility', 'visible');
  });
  closeBtn.on('click', function() {
    // Change the display property of '.product-images-alternate-slider.slider-for'
    modalEl.css('visibility', 'hidden');
  });
});